import { render, staticRenderFns } from "./ExpressPaymentConcepts.vue?vue&type=template&id=1a798f12"
import script from "./ExpressPaymentConcepts.vue?vue&type=script&lang=js"
export * from "./ExpressPaymentConcepts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports